import { Injectable } from '@angular/core'
import { ModelInclude } from './'

@Injectable()
export class ModelIncludeFactory {
  public fromIncludes(includes: string[]): ModelInclude {
    const includesAsObject = this._parseIncludes(includes)
    const result = new ModelInclude(includesAsObject)
    result['_memoizedArray'] = includes
    return result
  }

  private _parseIncludes(includes: string[]): { [key: string]: any } {
    return includes.reduce((includesTree, includeString) => {
      let currentBranch = includesTree
      includeString.split(ModelInclude.BRANCH_DELIMITER).forEach((relation) => {
        currentBranch[relation] = currentBranch[relation] || {}
        currentBranch = currentBranch[relation]
      })
      return includesTree
    }, {})
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/model-include/model-include.factory.ts